import React, {useEffect, useState} from 'react';
import './styles.scss';
import SvgNew from "../components/SvgNew";
import {NavLink, withRouter} from "react-router-dom";
import {compose} from "redux";
import {connect} from "react-redux";
import {getCurrentUserLogin, getRoles} from "../services/userRights";
import {apiGet, stopApiSession} from "../services/apiClient";

const MenuItem = ({entry, history}) => {
    const isActiveLink = () => {
        if (entry.isActive) {
            return entry.isActive(history.location);
        } else {
            return history.location.pathname === entry.url;
        }
    }

    const label = <div className='open-view'>{entry.label}</div>
    const icon = <SvgNew name={entry.icon}/>

    if (entry.roles) {
        let isView = false;
        let userRoles = getRoles();
        userRoles.forEach((userRole) => {
            if (entry.roles.includes(userRole)) {
                isView = true;
            }
        });
        if (!isView) return null;
    }

    let outerClassName = isActiveLink() ? "active" : "";

    const isBtn = entry.type === 'btn';

    if (entry.type === 'file' || isBtn) {
        return <li className={outerClassName}>
            <a onClick={isBtn ? entry.url : null} href={!isBtn ? entry.url : null} target='_blank'>
                {icon}
                {label}
            </a>
        </li>
    }

    if (entry.external) {
        return <li className={outerClassName}>
            <a href={entry.url} target="_blank">
                {icon}
                {label}
            </a>
        </li>
    } else {
        return <li className={outerClassName}>
            <NavLink to={entry.url}>
                {icon}
                {label}
            </NavLink>
        </li>
    }
}

const Menu = ({history}) => {
    const isParcelsLink = (location) => {
        let isNewParcel = location.pathname.startsWith('/parcels/new');
        let isParcels = location.pathname.startsWith('/parcels/');
        return isParcels && !isNewParcel;
    }

    let menuItemsInit = [
        {
            url: '/parcels/new',
            label: 'Создать отправление',
            icon: 'create-new',
            isActive: (location) => {
                return location.pathname.startsWith('/parcels/new');
            },
            roles: ['Author', 'Demo', 'Coordinator']
        },
        {
            url: '/parcels/list',
            label: 'Мои отправления',
            icon: 'box',
            isActive: (location) => isParcelsLink(location)
        },
        {
            url: '/reports/my',
            label: 'Мои отчеты',
            icon: 'table-report',
            isActive: (location) => {
                return location.pathname.startsWith('/reports/my');
            }
        },
        {
            url: '/dictionary/myaddresses',
            label: 'Мои адреса',
            icon: 'my-addresses',
            isActive: (location) => {
                return location.pathname.startsWith('/dictionary/myaddresses');
            },
        },
        {
            url: '/massupload',
            label: 'Массовые операции',
            icon: 'mass-operations',
            isActive: (location) => {
                return location.pathname.startsWith('/massupload');
            },
            roles: ['Author', 'Demo', 'Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/borderInsurance',
            label: 'Бордеро страхования',
            icon: 'border-insurance',
            isActive: (location) => {
                return location.pathname.startsWith('/borderInsurance')
            },
            roles: ['Coordinator']
        },
        {
            url: '/admin/companies/list',
            label: 'Юр. лица клиентов',
            icon: 'company-client',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/companies/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/admin/users/list',
            label: 'Пользователи',
            icon: 'users',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/users/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin', 'ClientAdmin']
        },
        {
            url: '/admin/rates/list',
            label: 'Коэффициенты',
            icon: 'rates',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/rates/')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/admin/instructions',
            label: 'Инструкции',
            icon: 'manual',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/instructions')
            },
            roles: ['Admin', 'GlobalAdmin']
        },
        {
            url: '/admin/stats',
            label: 'Статистика',
            icon: 'stats',
            isActive: (location) => {
                return location.pathname.startsWith('/admin/stats')
            },
            roles: ['Coordinator', 'Admin', 'GlobalAdmin']
        },
        {
            url: '/incoming-parcels',
            label: 'Входящие отправления',
            icon: 'incoming',
            isActive: (location) => {
                return location.pathname.startsWith('/incoming-parcels');
            },
            roles: ['Author', 'Demo', 'ClientAdmin']
        },
        {
            url: '/instructions',
            label: 'Инструкции',
            icon: 'manual',
            isActive: (location) => {
                return location.pathname.startsWith('/instructions')
            },
            roles: ['Author', 'Demo', 'ClientAdmin', 'Coordinator']
        },
        {
            url: getPoolingContractsUrl(),
            external: true,
            label: 'Подписание договора',
            icon: 'sign',
            isActive: () => false,
            roles: ['Demo']
        },
        // {
        //     url: '',
        //     label: 'Инструкции пользователя',
        //     icon: 'instruction',
        //     type: 'file'
        // }
    ];
    const [menuItems, setMenuItems] = useState(menuItemsInit);

    useEffect(() => {
        let isMounted = true;
        
        apiGet('user/company')
            .then(data => {
                if (!isMounted) return;
                
                if (data && data.publicOfferUrl) {
                    setMenuItems(menuItems => ([
                        ...menuItems,
                        {
                            url: data.publicOfferUrl,
                            label: 'Пользовательское соглашение',
                            icon: 'info',
                            type: 'file'
                        }
                    ]))
                }
            });
            
        return () => {
            isMounted = false;
        };
    }, [])

    const [roleNames, setRoleNames] = useState('');

    const getAllRoles = () => {
        apiGet('ref/roles/list')
            .then(data => {
                setRoleNames(getRoles().map(r => ((data.entries || []).find(rn => rn.name === r) || {}).displayName).join(', '))
            })
            .catch(err => {
                console.log(err)
            });
    }

    useEffect(() => {
        getRoles() && getAllRoles();
    }, [])

    return (
        <div className='new-menu'>
            <div className='new-menu__data'>
                <div className='new-menu__logo' onClick={() => history.push('/')}>
                    <SvgNew name='po-ex-logo'/>
                </div>
                <section className='new-menu__links'>
                    {
                        menuItems.map(item => (
                            <MenuItem key={item.url} entry={item} history={history}/>
                        ))
                    }
                </section>
            </div>

            <section className='new-menu__user'>
                <div className='new-menu__user-info open-view'>
                    <div className='new-menu__login'>{getCurrentUserLogin()}</div>
                    <div className='new-menu__roles'>{roleNames}</div>
                </div>
                <section className='new-menu__links without-line'>
                    <MenuItem
                        entry={{
                            url: '/profile',
                            label: 'Профиль',
                            icon: 'profile',
                            isActive: (location) => {
                                return location.pathname.startsWith('/profile')
                            },
                        }}
                        history={history}
                    />
                    <MenuItem
                        entry={{
                            url: () => stopApiSession(true),
                            label: 'Выйти',
                            icon: 'exit',
                            type: 'btn'
                        }}
                        history={history}
                    />
                </section>
            </section>
        </div>
    );
};

export default compose(
    withRouter,
    connect()
)(Menu);


// WEBPACK FOOTER //
// ./App/menu/menu_v2.jsx